import { styled } from '@ori-ui/mui';
import { CategoryPageContainer, LandingPageContainer, categoryPageClasses, landingPageClasses } from '@ori/editorial-category';
export const StyledLandingPageContainer = styled(LandingPageContainer)((param)=>{
    let { theme } = param;
    return {
        background: theme.palette.background.default,
        padding: theme.spacing(0, 3),
        [theme.breakpoints.up('sm')]: {
            padding: theme.spacing(0, 5),
            [".".concat(landingPageClasses.topBanner)]: {
                margin: theme.spacing(0, -5, 6, -5)
            }
        }
    };
});
export const StyledCategoryPageContainer = styled(CategoryPageContainer)((param)=>{
    let { theme } = param;
    return {
        background: theme.palette.background.default,
        padding: theme.spacing(0, 3),
        [theme.breakpoints.up('sm')]: {
            padding: theme.spacing(0, 5),
            [".".concat(categoryPageClasses.topBanner)]: {
                margin: theme.spacing(0, -5, 6, -5)
            }
        }
    };
});
export const Root = styled('div')((param)=>{
    let { theme } = param;
    return {
        background: theme.palette.background.default
    };
});
